import React from "react";
import PropTypes from "prop-types";
// react plugin for creating charts
// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";

// import ArrowUpward from "@material-ui/icons/ArrowUpward";
// import ArrowDownward from "@material-ui/icons/ArrowDownward";
import AirportIcon from "@material-ui/icons/DoneAll";
import GraphLegend from "@material-ui/icons/Stop";
import RefreshIcon from "@material-ui/icons/Refresh";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DatePicker from "./MonthPicker.jsx";
import { InlinePageRequesting } from "../../utils/PageUtility";
import TokenUtilizationChart from "./graphs/tokenUtilization";
import TokenActivityChart from "./graphs/tokenActivity";

import "./styles.css";

import {
    defaultTokenUtilizationData,
    setTokenUtilizationData,
    defaultTokenActivityData,
    setTokenActivityData,
    defaultAirportTokenUtilizationData,
    setAirportTokenUtilizationData
} from "variables/charts";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import {alertActions} from "../../_actions";
import withMobileDialog from "@material-ui/core/withMobileDialog/index";
import {connect} from "react-redux";
import {SummaryCard} from "./SummaryCard";
import {commonService} from "../../_services";
import {EmptyRecord} from "../../utils/PageUtility";
import LatestToken from "./latestToken";
import {appConstants} from "../../_constants";
import EmptyIcon from "@material-ui/icons/Info";
import {appHelpers} from "../../_helpers";

const today = new Date();
let yesterday = new Date();
yesterday.setDate(today.getDate() - 30);

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMonthValue: "",
        dashboard: false,
        StartDate: yesterday,
        EndDate: today,
        BillableAmount: 0,
        BillablePassengerCount: 0,
        FlightCount: 0,
        PassengerCount: 0,
        TokenPurchased: 0,
        TokenUtilized: 0,
        AirportCode: "-1",
        AirlineId: "-1",
        open: false,
        latestToken: [],
        tokenUtilizationChartData: defaultTokenUtilizationData,
        tokenActivityChartData: defaultTokenActivityData,
        tokenPurchasedChartData: defaultTokenActivityData,
        tokenUsedChartData: defaultTokenActivityData,
        airportTokenUsedChartData: defaultAirportTokenUtilizationData,
    };
  }

  componentDidMount(){
      const { user } = this.props;
      if (user.AppRole === appConstants.ROLES.AIRLINE) {
          this.setState({AirlineId: user.AirlineId}, this.initializePage)
      } else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
          this.setState({AirportCode: user.AirportCode}, this.initializePage)
      }else{
          this.initializePage();
      }
  }
  componentWillReceiveProps = function (nextProps) {
      const { dashboard } = nextProps;
      if(dashboard){
          const { summary } = dashboard.data;
          if(summary){
            const { billablePax, totalBillableAmount, tokensPurchased, unUtilizedToken, totalFlights } = summary;
            this.setState({billablePax, totalBillableAmount, tokensPurchased, unUtilizedToken, totalFlights, open: false})
          }
      }
  };

  initializePage = () => {
    this.getLatestTokenPurchase();
    this.getDashboardPageData();
  };
  getDashboardPageData = () => {
      const { dispatch } = this.props;
      let { StartDate, EndDate, AirportCode, AirlineId } = this.state;
      StartDate = appHelpers.formatDateSpecific(StartDate, "YYYY-MM-DD");
      EndDate = appHelpers.formatDateSpecific(EndDate, "YYYY-MM-DD");

      const payload = {StartDate, EndDate};
      const tokenUtilizationPayload = {
          "PageSize": 8,
          "From": 0,
          "Parameter": {
              StartDate, EndDate
          }
      };

      if(AirportCode !== "-1"){
          payload.AirportCode = AirportCode;
          tokenUtilizationPayload.Parameter.AirportCode = AirportCode;
      }
      if(AirlineId !== "-1"){
          payload.AirlineId = AirlineId;
          tokenUtilizationPayload.Parameter.AirlineId = AirlineId;
      }

      dispatch(alertActions.startRequest());
      Promise.all([
          commonService.fetchDashboardSummaryCard(payload),
          commonService.fetchTokenUtilizationByAirline(tokenUtilizationPayload),
          commonService.searchTokenActivity(payload),
          commonService.fetchTokenUtilizationByAirport(
              { ...payload , Count: 10 }
          ),
      ])
          .then(response => {
              const dashboardSummary = response[0];
              const tokenUtilization = response[1];
              const tokenActivity = response[2];
              const tokenUsageByAirport = response[3];
              if(dashboardSummary.status === appConstants.SUCCESS_RESPONSE ||
                tokenUtilization.status === appConstants.SUCCESS_RESPONSE ||
                tokenActivity.status === appConstants.SUCCESS_RESPONSE) {
                  const { BillableAmount, BillablePassengerCount, FlightCount, PassengerCount, TokenPurchased, TokenUtilized } = dashboardSummary.response.Source;
                  this.setState({
                      BillableAmount, BillablePassengerCount, FlightCount, PassengerCount, TokenPurchased, TokenUtilized,
                      open: false
                  });
                  this.packageTokenUtilization(tokenUtilization.response.Results);
                  this.packageTokenActivity(tokenActivity.response); //token activity
                  this.packageTokenUsageByAirport(tokenUsageByAirport.response); //token activity by airport
              }else{
                  dispatch(alertActions.error('Operation could not be completed at the moment'));
              }
            dispatch(alertActions.stopRequest());
          }).catch(err=>{
              dispatch(alertActions.stopRequest());
      })

  };

  handleDateChange = (date, target) => {
    this.setState({ [target]: date });
  };

  openDateDialog = event => {
      event.preventDefault();
      this.setState({ open: true });

  };
  handleDateDialogClose = () => {
        this.setState({ open: false });
    };

  getLatestTokenPurchase = (refresh) => {
      const { dispatch } = this.props;
      const { AirlineId, AirportCode } = this.state;
      if(refresh)
          dispatch(alertActions.startRequest());

      const payload = { Count: 10};
      if(AirlineId !== "-1")
          payload.AirlineId = AirlineId;
      if(AirportCode !== "-1")
          payload.AirportCode = AirportCode;

      commonService.fetchLatestTokensPurchase(payload)
          .then(res => {
              if(refresh)
                  dispatch(alertActions.stopRequest());

                if(res.status === appConstants.SUCCESS_RESPONSE){
                    this.setState({ latestToken: res.response.Results });
                }else{
                    this.props.dispatch(alertActions.error(res.response.join(',')));
                }
          }).catch(err => {
            this.props.dispatch(alertActions.error('Failed to get latest token'));
      })
    };

  packageTokenUtilization = (tokenData) => {
      const tokenUtilizationChartData = setTokenUtilizationData(tokenData);
      this.setState({tokenUtilizationChartData});
  };

  packageTokenActivity = (tokenData) => {
      const { tokenPurchasedChartData, tokenUsedChartData } = setTokenActivityData(tokenData.Results);
      this.setState({tokenPurchasedChartData, tokenUsedChartData});
  };

  packageTokenUsageByAirport = (tokenData) => {
      const airportTokenUsedChartData = setAirportTokenUtilizationData(tokenData.Results);
      this.setState({airportTokenUsedChartData});
  };

  render() {
    const { classes, fullScreen, requesting, user } = this.props;
    const { StartDate, EndDate, BillableAmount, BillablePassengerCount, FlightCount, TokenPurchased,
        PassengerCount, TokenUtilized, latestToken, tokenUtilizationChartData, tokenPurchasedChartData, airportTokenUsedChartData } = this.state;
    return (
      <div>
        {/* Summary Card */}
        <SummaryCard startDate={StartDate} endDate={EndDate}
                     openDateDialog={this.openDateDialog} classes={classes}
                     billablePax={BillablePassengerCount} totalBillableAmount={BillableAmount}
                     tokensPurchased={TokenPurchased}
                     passengerCount={PassengerCount}
                     unUtilizedToken={(TokenPurchased - TokenUtilized)} totalFlights={FlightCount}/>

        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader
                color="warning"
                style={{ background: "#f9f9f9", boxShadow: "none" }}
              >
                <h4 className={classes.cardTitle}>Tokens Utilization</h4>
                <p className={classes.cardCategory}>
                  Breakdown of token utilization by airlines
                </p>

                 <TokenUtilizationChart chartData={tokenUtilizationChartData}/>

              </CardHeader>
              <CardBody>
                <div>
                  <p className={classes.cardCategory}>
                    <span className={classes.dangerText}>
                      <GraphLegend className={classes.tokenArrowCardCategory} />{" "}
                      Token Purchased
                    </span>
                    {"  "}
                    &nbsp;
                    <span className={classes.dangerText}>
                      <GraphLegend
                        className={classes.billableArrowCardCategory}
                      />{" "}
                      Billable Passengers
                    </span>{" "}
                  </p>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <Card chart>
              <div>
                  <CardHeader color="warning"
                      style={{ background: "#f9f9f9", boxShadow: "none", minHeight: '250px' }}
                  >
                      {
                          (airportTokenUsedChartData.labels.length > 0) &&
                          <TokenUtilizationChart chartData={airportTokenUsedChartData} responsiveHeight={true}/>
                      }
                      {
                          (airportTokenUsedChartData.labels.length === 0) &&
                          <div>
                              <div style={{textAlign: 'center', marginTop: '70px'}}>
                                 <EmptyIcon  style={{fontSize:"60px", color: '#3c3939'}}/>
                              </div>
                              <h5 style={{ margin: 0, textAlign: 'center', color: '#3c3939'}}> No data captured!</h5>
                          </div>
                      }
                  </CardHeader>
                  <CardBody>
                      {
                          user.AppRole === appConstants.ROLES.AIRPORT_MANAGER &&
                          (
                              <div>
                                  <h4 className={classes.cardTitle}>Token Usage</h4>
                                  <p className={classes.cardCategory}>
                                    <span>
                                      <AirportIcon className={classes.upArrowCardCategory} />&nbsp;Token Utilization By Airport
                                    </span>{" "}
                                  </p>
                              </div>
                          )
                      }
                      {
                          user.AppRole !== appConstants.ROLES.AIRPORT_MANAGER &&
                          (
                              <div>
                                  <h4 className={classes.cardTitle}>Top Airports Usage</h4>
                                  <p className={classes.cardCategory}>
                                    <span>
                                      <AirportIcon className={classes.upArrowCardCategory} />&nbsp;Token Utilization By Airports
                                    </span>{" "}
                                  </p>
                              </div>
                          )
                      }

                  </CardBody>
              </div>

            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Card chart>
              <div>
                  <CardHeader color="danger"
                              style={{ background: "#f9f9f9", boxShadow: "none", minHeight: '250px' }}
                  >
                      <TokenActivityChart chartData={tokenPurchasedChartData}/>

                  </CardHeader>
                  <CardBody>
                      <h4 className={classes.cardTitle}>Token Activity</h4>
                      <p className={classes.cardCategory}>
                           <span className={classes.dangerText}>
                                 <GraphLegend className={classes.tokenArrowCardCategory} />{" "}
                                    Token Purchased
                            </span>
                                  {"  "}
                                  &nbsp;
                              <span className={classes.dangerText}>
                                  <GraphLegend
                                      className={classes.billableArrowCardCategory}
                                  />{" "}
                                  Token Utilized
                              </span>{" "}
                      </p>
                  </CardBody>
              </div>

            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="success">
                  <div style={{'float': 'left'}}>
                     <h4 className={classes.cardTitleWhite}>Token Purchase Stats</h4>
                     <p className={classes.cardCategoryWhite}>
                         Latest token purchased
                     </p>
                 </div>
                  <div style={{'float': 'right'}}>
                      <span style={{cursor: 'pointer'}} onClick={() => this.getLatestTokenPurchase(true)}>
                          <RefreshIcon/>
                      </span>
                  </div>
              </CardHeader>
              <CardBody>
                  {
                      (latestToken.length > 0) &&
                      <LatestToken classes={classes} latestToken={latestToken}/>
                  }
                  {
                      !latestToken.length &&
                      <EmptyRecord message={'No token yet!'}/>
                  }
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

          <Dialog
              fullScreen={fullScreen}
              open={this.state.open}
              onClose={this.handleClose}
              aria-labelledby="responsive-dialog-title"
          >
              <DialogTitle id="responsive-dialog-title">
                  {"Date Range"}
              </DialogTitle>
              <div>
                  <DialogContent>
                      <DatePicker startDate={StartDate} endDate={EndDate} handleDateChange={this.handleDateChange} onSubmit={this.getDashboardData}/>
                  </DialogContent>
                  {
                      requesting &&
                      <div style={{textAlign: 'center', marginBottom: '5px'}}>
                          <InlinePageRequesting/>
                      </div>
                  }
                  {
                      !requesting &&
                      <div style={{'textAlign': 'center', marginBottom: '10px'}}>
                          <Button onClick={this.handleDateDialogClose} color="danger">
                              Dismiss
                          </Button> &nbsp;
                          <Button onClick={this.getDashboardPageData} color="primary" autoFocus>
                              Proceed
                          </Button>
                      </div>
                  }
              </div>
          </Dialog>

      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state, ownProps) {
    const { modal, alert, airlines, requesting, dashboard, user } = state;
    return {
        modal,
        alert,
        airlines,
        requesting,
        dashboard,
        user
    };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(Dashboard)));



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx